import { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, CardActionArea, Box, Typography, Grid } from '@mui/material';
import { CSVLink } from 'react-csv';

const TechResultsPane = (props) => {
    const [ maxResultsCount, setMaxResultsCount ] = useState(8);

    useEffect(() => {
        loadTechProviders();
    }, []);

    useEffect(() => {
        if (props.refreshList) {
            loadTechProviders();
            props.setRefreshList(false);
        }
    }, [props.refreshList])

    const loadTechProviders = async () => {
        let { data } = await props.db
            .schema('api')
			.from('tech_providers')
			.select('*')
            .is('approved', props.admin === true ? false : true);
        props.setTechProviders(data || []);
        //if (props.admin === true) {
          props.setFilteredTechProviders(data || []);
        //}
        //console.log(data);
    };

    const getTechProviderName = (id) => {
        if (props.techProviders && props.techProviders.length > 0) {
            let tp = props.techProviders.find(o => o.id === id);
            if (tp) {
                return tp.name;
            }
        }
        return "";
    };
    
    return (
    <div style={{padding:20}}>
        <Grid container spacing={2}>
            <Grid size={12} >
            <p style={{color: 'black'}}>There are {props.filteredTechProviders.length} providers that match your search&nbsp;
                { props.filteredTechProviders.length > 0 && <CSVLink style={{color: '#A2D9E7'}} data={props.filteredTechProviders}>(download selection)</CSVLink>
                }:</p>
            </Grid>
    {props.filteredTechProviders.slice(0, maxResultsCount).map((item) => (
        <Grid size={{xs:12, sm:6, md:4, lg:3 }} key={`TechResultsGrid${item.id}`}>
        <Card sx={{ display: "flex", width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }} key={`TechResultsCard${item.id}`}>
            <CardActionArea
                onClick={() => props.onSelectResult(item)}
                sx={{ height: "100%"}}
                >
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                        <Box sx={{display: 'flex', padding: '5px'}}>
                            <CardMedia
                                component="img"
                                sx={{ width: 100 }}
                                image={item.logo}
                                alt="Logo"
                            />
                            <Box sx={{paddingLeft: '10px'}}>
                                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                    Technology Provider:{<br/>}
                                </Typography>
                                <Typography variant="h5" color="#0b7dbb" fontWeight={'bold'}>
                                    {item.name}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '5px'}}>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                What we do:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.summary}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Technologies provided:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.technology_types.join(", ")}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Sectors served:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.sectors.join(", ")}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Location:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.location}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Website:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                <a href={item.website}>{item.website}</a>
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                SDGs:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.sdgs.map((s) => <img key={`sdg${s}`} style={{padding: '2px'}} width="50px" src={`/sdg${s}.png`}/>)}
                            </Typography>
                        </Box>
                </CardContent>
            </CardActionArea>
        </Card>
      </Grid>
    ))}
    </Grid>
    </div>
    );
};

export default TechResultsPane;